// extracted by mini-css-extract-plugin
export default {"inputDiv":"editFull_inputDiv__5yq6T","chapterRow":"editFull_chapterRow__6CzCc","questionRow":"editFull_questionRow__wqbzy","placeEnd":"editFull_placeEnd__HI-ci"};